import React from "react";
export default function Downlinesportsplsportswise() {
    return(
        <div className="allcommon">
        <section className="main-inner-outer py-4">
  <div className="container-fluid">
    <div className="row">
      <div className="db-sec">
        <h2 className="common-heading">Profit/Loss</h2>
      </div>
      <div className="mt-2 col-lg-12 col-md-12 col-sm-12">
        <div className="inner-wrapper">
          <section className="account-table donwline-match-pl w-100">
            <div className="responsive transaction-history w-100">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Title</th>
                    <th scope="col">P&amp;L</th>
                    <th scope="col">Com+</th>
                    <th scope="col">Com-</th>
                    <th scope="col">Won By</th>
                    <th scope="col">Net P&amp;L</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-start">Total</td>
                    <td>
                      <span className="text-success back-trans">
                        (8,710.00)
                      </span>
                    </td>
                    <td>
                      <span className="text-success back-trans"> 0.00</span>
                    </td>
                    <td>
                      <span className="text-danger back-trans">0.00</span>
                    </td>
                    <td />
                    <td>
                      <span className="text-success back-trans">
                        (8,710.00)
                      </span>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td className="text-start">
                      West Indies v Pakistan &gt; 25 Over WI | Decision 64
                    </td>
                    <td>
                      <span className="text-success">(100.00)</span>
                    </td>
                    <td>
                      <span className="text-success">0.00</span>
                    </td>
                    <td>
                      <span className="text-danger">0.00</span>
                    </td>
                    <td />
                    <td>
                      <span className="text-success">(100.00)</span>
                    </td>
                    <td className="">
                      <a href="/matchBetDetailssports-wise">
                        <button className="btn-send">Show Bets</button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">
                      West Indies v Pakistan &gt; 55 Over WI | Decision 164
                    </td>
                    <td>
                      <span className="text-success">(4,000.00)</span>
                    </td>
                    <td>
                      <span className="text-success">0.00</span>
                    </td>
                    <td>
                      <span className="text-danger">0.00</span>
                    </td>
                    <td />
                    <td>
                      <span className="text-success">(4,000.00)</span>
                    </td>
                    <td className="">
                      <a href="/matchBetDetailssports-wise">
                        <button className="btn-send">Show Bets</button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">
                      West Indies v Pakistan &gt; 50 Over WI | Decision 149
                    </td>
                    <td>
                      <span className="text-success">(4,000.00)</span>
                    </td>
                    <td>
                      <span className="text-success">0.00</span>
                    </td>
                    <td>
                      <span className="text-danger">0.00</span>
                    </td>
                    <td />
                    <td>
                      <span className="text-success">(4,000.00)</span>
                    </td>
                    <td className="">
                      <a href="/matchBetDetailssports-wise">
                        <button className="btn-send">Show Bets</button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">
                      West Indies v Pakistan &gt; 30 Over WI | Decision 79
                    </td>
                    <td>
                      <span className="text-success">(110.00)</span>
                    </td>
                    <td>
                      <span className="text-success">0.00</span>
                    </td>
                    <td>
                      <span className="text-danger">0.00</span>
                    </td>
                    <td />
                    <td>
                      <span className="text-success">(110.00)</span>
                    </td>
                    <td className="">
                      <a href="/matchBetDetailssports-wise">
                        <button className="btn-send">Show Bets</button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">
                      West Indies v Pakistan &gt; 20 Over PAK | Decision 103
                    </td>
                    <td>
                      <span className="text-success">(500.00)</span>
                    </td>
                    <td>
                      <span className="text-success">0.00</span>
                    </td>
                    <td>
                      <span className="text-danger">0.00</span>
                    </td>
                    <td />
                    <td>
                      <span className="text-success">(500.00)</span>
                    </td>
                    <td className="">
                      <a href="/matchBetDetailssports-wise">
                        <button className="btn-send">Show Bets</button>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</section>


</div>
    );
}